import React, { useContext, useEffect, useState } from "react";
import BlinkingStar from "./BlinkingStar";
import axios from "axios";
import { serverInfo } from "../../../App";
import { Link } from "react-router-dom";
import { useI18n } from "../../../i18n";

const BlinkingAuditions = () => {
  const { imageCdnUrl, videoCdnUrl } = useContext(serverInfo);
  const [auditionList, setAuditionList] = useState([]);
  const [auditionItem, setAuditionItem] = useState(null);
  const { t } = useI18n();

  useEffect(() => {
    let isMounted = true;
    const fetchPosts = async () => {
      const all_posts = await axios.get("/api/user/audition/enrolled");
      if (isMounted && all_posts.status === 200) {
        if (all_posts?.data?.posts !== "undefined" && all_posts.data.posts.length > 0) {
          setAuditionList(all_posts?.data?.posts);
          setAuditionItem(all_posts?.data?.posts[0]);
        }
      }
    };

    fetchPosts();
    return () => {
      isMounted = false;
    };
  }, [setAuditionList, setAuditionItem]);

  return (
    <>
      {auditionList && auditionList.length > 0 ? (
        <div className="MobileLeft left-col-box p-3 mt-3">
          <div className={"live-text-sln HColor"}>
            {t("Register_New_Audition_Text")}
          </div>
          <div className="new-auditions">
            {auditionItem != null ? (
              <Link
                key={auditionItem.event_id}
                to={`/audition/registration/${auditionItem.event_id}`}
              >
                <BlinkingStar
                  key={auditionItem.event_id}
                  imageSrc={imageCdnUrl + auditionItem.banner}
                  title={auditionItem.title}
                />
              </Link>
            ) : (
              ""
            )}
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default BlinkingAuditions;
